import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import * as auth from "@/libs/auth";
import {
  Toast
} from 'vant';
import store from "@/store";


Vue.use(VueRouter)

// 解决Vue-Router升级导致的Uncaught(in promise)
// V3.1.0版本里面新增功能：push和replace方法会返回一个promise, 你可能在控制台看到未捕获的异常
// 解决方法：对Router原型链上的push、replace方法进行重写，这样就不用每次调用方法都要加上catch
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  else
    return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject)
  else
    return originalReplace.call(this, location).catch(err => err)
}


const routes = [{
  path: '/',
  name: 'Home',
  component: Home,
  meta: {
    title: "健康体检",
    isReleased: true,
  }
},
{
  path: '/union',
  name: 'Union',
  component: () => import( /* webpackChunkName: "hospital" */ '@/views/hospital/union.vue'),
  meta: {
    title: "体检院区",
    isReleased: true,
  }
},
{
  path: '/about',
  name: 'About',
  component: () => import( /* webpackChunkName: "hospital" */ '@/views/hospital/about.vue'),
  meta: {
    title: "机构介绍",
    isReleased: true,
  }
},
{
  path: '/notice',
  name: 'Notice',
  component: () => import( /* webpackChunkName: "hospital" */ '@/views/hospital/notice.vue'),
  meta: {
    title: "体检须知",
    isReleased: true,
  }
},
{
  path: '/articles',
  name: 'ArticleList',
  component: () => import( /* webpackChunkName: "hospital" */ '@/views/hospital/articleList.vue'),
  meta: {
    title: "文章资讯"
  }
},
{
  path: '/article',
  name: 'Article',
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import( /* webpackChunkName: "hospital" */ '@/views/hospital/article.vue'),
  meta: {
    title: "文章资讯"
  }
},
{
  path: '/location',
  name: 'Location',
  component: () => import( /* webpackChunkName: "hospital" */ '@/views/hospital/location.vue'),
  meta: {
    title: "地图位置",
    isReleased: true,
  }
},
{
  path: '/feedback',
  name: 'feedback',
  props: true,
  component: () => import( /* webpackChunkName: "hospital" */ '@/views/hospital/user-rating.vue'),
  meta: {
    title: "评价反馈",
    requiresAuth: true,
    isReleased: true,
  }
},
{
  path: '/survey',
  name: 'Survey',
  component: () => import( /* webpackChunkName: "survey" */ '@/views/survey/index.vue'),
  meta: {
    title: "健康问卷"
  }
},
{
  path: '/survey/fill',
  name: 'SurveyFill',
  component: () => import( /* webpackChunkName: "survey" */ '@/views/survey/fill.vue'),
  meta: {
    title: "健康问卷"
  }
},
{
  path: '/survey/detail',
  name: 'SurveyDetail',
  component: () => import( /* webpackChunkName: "survey" */ '@/views/survey/result.vue'),
  meta: {
    title: "健康问卷"
  }
},
{
  path: '/survey/recommend',
  name: 'SurveyRecommend',
  component: () => import( /* webpackChunkName: "survey" */ '@/views/survey/recommend.vue'),
  meta: {
    title: "健康问卷"
  }
},
{
  path: '/survey/project',
  name: 'SurveyProject',
  component: () => import( /* webpackChunkName: "survey" */ '@/views/survey/project.vue'),
  meta: {
    title: "订制体检方案"
  }
},
{
  path: '/survey/success',
  name: 'SurveySuccess',
  component: () => import( /* webpackChunkName: "survey" */ '@/views/survey/success.vue'),
  meta: {
    title: "健康问卷"
  }
},
// {
//   path: '/survey/customize',
//   name: 'SurveyCustomize',
//   component: () => import( /* webpackChunkName: "survey" */ '@/views/survey/customize.vue')
// },
{
  path: '/packageList',
  name: 'packageList',
  component: () => import( /* webpackChunkName: "personal" */ '@/views/personal/packageList.vue'),
  meta: {
    title: "体检套餐"
  }
},
{
  path: '/packageDetail',
  name: 'packageDetail',
  component: () => import( /* webpackChunkName: "personal" */ '@/views/personal/packageDetail.vue'),
  meta: {
    title: "体检套餐详情"
  }
},
{
  path: '/namelist',
  name: 'namelist',
  component: () => import( /* webpackChunkName: "personal" */ '@/views/personal/nameList.vue'),
  meta: {
    title: "体检人员"
  }
},
{
  path: '/submitOrder',
  name: 'submitOrder',
  component: () => import( /* webpackChunkName: "personal" */ '@/views/order/submitOrder.vue'),
  meta: {
    title: "确认预约"
  }
},
{
  path: '/orderSuccess',
  name: 'orderSuccess',
  props: false,
  component: () => import( /* webpackChunkName: "personal" */ '@/views/order/orderSuccess.vue'),
  meta: {
    title: "预约成功"
  }
},
{
  path: '/orderPayResult',
  name: 'orderPayResult',
  props: false,
  component: () => import( /* webpackChunkName: "personal" */ '@/views/order/orderPayResult.vue'),
  meta: {
    title: "订单支付结果"
  }
},
{
  path: '/orderPayResultWN',
  name: 'orderPayResultWN',
  props: false,
  component: () => import( /* webpackChunkName: "personal" */ '@/views/order/orderPayResultWN.vue'),
  meta: {
    title: "订单支付结果"
  }
},
{
  path: '/orderlist',
  name: 'orderList',
  component: () => import( /* webpackChunkName: "order" */ '@/views/order/orderList.vue'),
  meta: {
    title: "预约列表",
    requiresAuth: true,
  }
},
{
  path: '/orderinfo',
  name: 'orderInfo',
  component: () => import( /* webpackChunkName: "order" */ '@/views/order/orderInfo.vue'),
  meta: {
    title: "预约详情",
    requiresAuth: true,
  }
},
{
  path: '/login',
  name: 'login',
  component: () => import( /* webpackChunkName: "account" */ '@/views/user/login.vue'),
  meta: {
    title: "用户登录",
    isReleased: true,
  }
},
{
  path: '/signup',
  name: 'signup',
  component: () => import( /* webpackChunkName: "account" */ '@/views/user/signup.vue'),
  meta: {
    title: "注册",
    isReleased: true,
  }
},
{
  path: '/signup_profile',
  name: 'signup_profile',
  component: () => import( /* webpackChunkName: "account" */ '@/views/user/signup_profile.vue'),
  meta: {
    title: "填写信息",
    isReleased: true,
  }
},
{
  path: '/userCenter',
  name: 'userCenter',
  // props: true,
  component: () => import( /* webpackChunkName: "account" */ '@/views/user/index.vue'),
  meta: {
    title: "个人中心"
  }
},
{
  path: '/user/editpwd',
  name: 'ChangePassword',
  props: true,
  component: () => import( /* webpackChunkName: "account" */ '@/views/user/password.vue'),
  meta: {
    title: "修改密码"
  }
},
{
  path: '/user/addProfile',
  name: 'addProfile',
  props: true,
  component: () => import( /* webpackChunkName: "account" */ '@/views/user/profile_add.vue'),
  meta: {
    title: "新增体检人",
    requiresAuth: true,
  }
},
{
  path: '/user/editProfile',
  name: 'editProfile',
  props: true,
  component: () => import( /* webpackChunkName: "account" */ '@/views/user/profile_edit.vue'),
  meta: {
    title: "修改人员信息",
    requiresAuth: true,
  }
},
{
  path: '/user/profileList',
  name: 'profileList',
  props: true,
  component: () => import( /* webpackChunkName: "account" */ '@/views/user/profile_list.vue'),
  meta: {
    title: "体检人员管理",
    requiresAuth: true,
  }
},
{
  path: '/company/orderlist',
  name: 'companyOrderList',
  component: () => import( /* webpackChunkName: "company" */ '@/views/company/orderList.vue'),
  meta: {
    title: "团队预约",
    requiresAuth: true,
  }
},
{
  path: '/company/orderAddItem',
  name: 'companyOrderAddItem',
  component: () => import( /* webpackChunkName: "company" */ '@/views/company/orderAddItem.vue'),
  meta: {
    title: "团队预约",
    requiresAuth: true,
  }
},
{
  path: '/company/orderAddCombo',
  name: 'companyOrderAddCombo',
  component: () => import( /* webpackChunkName: "company" */ '@/views/company/orderAddCombo.vue'),
  meta: {
    title: "团队预约",
    requiresAuth: true,
  }
},
{
  path: '/company/groupSelect',
  name: 'companyGroupSelect',
  component: () => import( /* webpackChunkName: "company" */ '@/views/company/groupSelect.vue'),
  meta: {
    title: "团队预约",
    requiresAuth: true,
  }
},
{
  path: '/company/orderDetail',
  name: 'companyOrderDetail',
  component: () => import( /* webpackChunkName: "company" */ '@/views/company/orderDetail.vue'),
  meta: {
    title: "团队预约",
    requiresAuth: true,
  }
},
{
  path: '/company/orderInfo',
  name: 'companyOrderInfo',
  component: () => import( /* webpackChunkName: "company" */ '@/views/company/orderInfo.vue'),
  meta: {
    title: "团队预约详情",
    requiresAuth: true,
  }
},
{
  path: '/company/orderSuccess/:orderinfo',
  name: 'companyOrderSuccess',
  component: () => import( /* webpackChunkName: "company" */ '@/views/company/orderSuccess.vue'),
  meta: {
    title: "团队预约",
    requiresAuth: true,
  }
},
{
  path: '/company/teamRegister',
  name: 'companyTeamRegister',
  component: () => import( /* webpackChunkName: "company" */ '@/views/company/teamRegister.vue'),
  meta: {
    title: "团队预约",
    requiresAuth: true,
  }
},
{
  path: '/reports',
  name: 'reportlist',
  component: () => import( /* webpackChunkName: "report" */ '@/views/report/list.vue'),
  meta: {
    title: "体检报告",
    isReleased: true,
    requiresAuth: true,
  }
},
{
  path: '/report',
  name: 'report',
  component: () => import( /* webpackChunkName: "report" */ '@/views/report/detail.vue'),
  meta: {
    title: "体检报告详情",
    isReleased: true,
    requiresAuth: true,
  }
},
{
  path: '/pdfreport',
  name: 'pdfreport',
  component: () => import( /* webpackChunkName: "report" */ '@/views/report/pdf.vue'),
  meta: {
    title: "体检报告详情",
    isReleased: true,
  }
},
{
  path: '/report/compareList',
  name: 'reportCompareList',
  component: () => import( /* webpackChunkName: "report" */ '@/views/report/compareList.vue'),
  meta: {
    title: "历史对比",
    isReleased: true,
    requiresAuth: true,
  }
},
{
  path: '/report/comparePage',
  name: 'reportComparePage',
  component: () => import( /* webpackChunkName: "report" */ '@/views/report/comparePage.vue'),
  meta: {
    title: "历史对比",
    isReleased: true,
    requiresAuth: true,
  }
},
{
  path: '/queue/login',
  name: 'queueLogin',
  props: true,
  component: () => import('@/views/queue/Login.vue'),
  meta: {
    title: "体检排队",
    requiresAuth: false,
    isReleased: true,
  }
},
{
  path: '/queue/state',
  name: 'queueState',
  props: true,
  component: () => import('@/views/queue/QueueState.vue'),
  meta: {
    title: "体检排队",
    requiresAuth: false,
    isReleased: true,
  }
},
{
  path: '/queue',
  name: 'queue',
  props: true,
  component: () => import('@/views/queue/Index.vue'),
  meta: {
    title: "体检排队",
    requiresAuth: true,
    isReleased: true,
  }
},
{
  path: '/guideline',
  name: 'guideline',
  props: true,
  component: () => import('@/views/queue/Guideline.vue'),
  meta: {
    title: "电子导检单",
    requiresAuth: true,
    isReleased: true,
  }
},
{
  path: '/portal',
  name: 'portal',
  props: true,
  component: () => import('@/views/portal.vue'),
  meta: {
    title: "正在跳转",
    isReleased: true,
  }
},
{
  path: '/ssoLogin',
  name: 'ssoLogin',
  props: true,
  component: () => import('@/views/user/sso_login.vue'),
  meta: {
    title: "正在跳转",
    isReleased: true,
  }
},
{
  path: '/error',
  name: 'error',
  component: () => import('@/views/hospital/error.vue'),
  meta: {
    isReleased: true,
  }
},
{
  path: '*',
  name: '404',
  component: () => import('@/views/hospital/error.vue'),
},

]

const renji_routes = [{
  path: '/',
  name: 'Home',
  component: () => import( /* webpackChunkName: "queue" */ '@/views/queue/Login.vue'),
  meta: {
    title: "体检排队",
    requiresAuth: false,
    isReleased: false,
    isDevelop: false,
  }
},
{
  path: '/queue',
  name: 'queue',
  props: true,
  component: () => import( /* webpackChunkName: "queue" */ '@/views/queue/QueueState.vue'),
  meta: {
    title: "体检排队",
    requiresAuth: false,
    isReleased: false,
    isDevelop: false,
  }
},
{
  path: '/queue/login',
  name: 'queueLogin',
  props: true,
  component: () => import( /* webpackChunkName: "queue" */ '@/views/queue/Login.vue'),
  meta: {
    title: "体检排队",
    requiresAuth: false,
    isReleased: false,
    isDevelop: false,
  }
},
{
  path: '/error',
  name: 'error',
  component: () => import('@/views/hospital/error.vue'),
  meta: {
    isReleased: true,
  }
},
{
  path: '*',
  name: '404',
  component: () => import('@/views/hospital/error.vue'),
},

]


const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
  //routes: window.Configs.Routes == 'renji' ? renji_routes : routes
})

router.beforeEach((to, from, next) => {

  // beforeEach钩子函数不支持获取目标路由是否为replace，暂时改为手工判断路由
  let replaceRoutes = ['orderSuccess']
  let replace = replaceRoutes.indexOf(to.name) >= 0

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }

  //如果是错误页，直接跳转
  if (to.path == "/error") {
    console.log("error page")
    next();
    return;
  }
  if (to.meta.isDevelop) {
    Toast("正在开发中");
    next(false);
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    console.log("match route ");
    // 检查是否登录，如果未登录，跳转到登录页
    // if not, redirect to login page.
    if (!auth.loggedIn()) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
      console.log("redirect to login page");
      return;
    } else {
      console.log("is loggind");
    }
  }
  //排除以下路由,不需要hospid
  let excludePaths = ['Union', 'Error', '404'];
  // console.log(store.state.hospital.hospInfo);
  if ((to.query && to.query.hospid) || excludePaths.indexOf(to.name) >= 0) {
    next({
      replace: to.replace
    });
  } else {
    //判断from是否带参数
    if (from.query && from.query.hospid) {
      to.query.hospid = from.query.hospid;
    } else {
      to.query.hospid = localStorage.getItem("hospid");
    }
    if (!to.query.hospid) {
      next({
        path: "/error"
      });
    } else {
      //如果是从登录页跳转过来的，
      if (from.path == "/login") {
        next({
          path: to.path,
          query: to.query,
          replace: true,
        })
      } else {
        if (to.params) {
          next({
            name: to.name,
            params: to.params,
            query: to.query,
            replace: replace,
          })
        } else {
          next({
            path: to.path,
            query: to.query,
            replace: replace,
          })
        }
      }
    }
  }
})

//滚动到顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});


export default router